import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

export default function Register() {
  return (
    <Container
      id="register"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 4 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: 'center',
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          sx={{ color: 'text.primary' }}
        >
          Ready to Join?
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          We are excited to welcome you or your child onto our team. However if you are reading this it means you likely came directly from orientation, details like when our interest meeting will be held and how to pay dues have not be formalized yet. For now sign up to recieve new-member information as it comes out:
        </Typography>
      </Box>
      <Button
        color="primary"
        variant="contained"
        size="large"
        href="https://forms.cloud.microsoft/r/0qVjXa4wA3"
        target="_blank"
        rel="noopener noreferrer"
      >
        Register
      </Button>
    </Container>
  );
}
